import React from "react"
import FontSelect from "@kit/design/font-select"
import Select from "@kit/design/select-menu"
import { filterWeights, fontOptions } from "app/regions/blocks/shared/fonts"

export function FontSettings({ fontFamily, fontWeight, onChange }) {
  const filteredWeightOptions = filterWeights(fontFamily)

  return (
    <div>
      <div className="font-semibold text-gray-700 mb-1">Font</div>
      <div className="grid grid-cols-5 gap-1">
        <FontSelect
          className="col-span-3"
          options={fontOptions}
          value={fontFamily}
          onChange={e => {
            onChange("fontFamily", e.target.value)
            onChange("fontWeight", 400)
          }}
        />
        <Select
          className="col-span-2"
          options={filteredWeightOptions}
          value={fontWeight}
          onChange={e => {
            onChange("fontWeight", e.target.value)
          }}
        />
      </div>
    </div>
  )
}
